export const SITE_URL = 'https://www.tihonline.co.uk'

export const seoByRoute = {
  home: {
    title: 'The Island House | Fish & Chips Done Properly',
    description: 'Traditional fish and chips, freshly cooked across the Black Country, Birmingham, Wolverhampton and Evesham. Find your nearest Island House and order online.'
  },
  ourfood: {
    title: 'Our Food | Fish & Chips, Kebabs & More | The Island House',
    description: 'Explore The Island House menu: 100% cod, traditional chips, kebabs, burgers, chicken, vegetarian favourites and classic chippy sides.'
  },
  order: {
    title: 'Order Fish & Chips Online | The Island House',
    description: 'Order The Island House fish and chips online for collection or delivery from your nearest location.'
  },
  locations: {
    title: 'Fish & Chip Shop Locations | The Island House',
    description: 'Find your nearest Island House fish and chip shop. View locations across the West Midlands and Evesham and order online.'
  },
  contact: {
    title: 'Contact The Island House | Fish & Chip Shops',
    description: 'Contact The Island House or find your nearest shop for help with orders, collection, delivery and opening information.'
  },
  appdownload: {
    title: 'Download The Island House App',
    description: 'Download The Island House app to order your favourite fish and chips quickly from your nearest shop.'
  },
  tipton: locationSeo('Tipton', '134 Toll End Rd, Tipton, West Midlands, DY4 0ET', '01215 204348', 52.54157, -2.03937),
  staffordrd: locationSeo('Stafford Road, Wolverhampton', '160 Stafford Rd, Wolverhampton, WV10 6JT', '01902 902600', 52.60649, -2.12978),
  edgbaston: locationSeo('Edgbaston, Birmingham', '7 Hollies Croft, Birmingham, B5 7QN', '01214 405452', 52.45722, -1.90643),
  newbridge: locationSeo('Newbridge, Wolverhampton', '103-105 Newbridge Cres, Wolverhampton, WV6 0LF', '01902 752559', 52.59590, -2.15917),
  evesham: locationSeo('Evesham', '4-5 Merstow Grn, Evesham, WR11 4BB', '01384 594685', 52.09187899401197, -1.9494407184401172),
  shardend: locationSeo('Shard End, Birmingham', '9 Ownall Road, Birmingham, B34 7AH', '0121 730 2379', 52.494624072668906, -1.7777356464638834),
  wednesbury: locationSeo('Wednesbury', '299 Crankhall Lane, Wednesbury, WS10 0DX', '0121 502 3140', 52.55631783677585, -2.000718198008359),
  returnspolicy: { title: 'Returns Policy | The Island House', description: 'Read The Island House returns and refund policy.' },
  socials: { title: 'The Island House on Social Media', description: 'Follow The Island House on social media for food, offers and updates.' },
  competition: { title: 'Competition | The Island House', description: 'View the latest competition from The Island House.' },
  competitionterms: { title: 'Competition Terms | The Island House', description: 'Read the terms and conditions for The Island House competition.' }
}

function locationSeo(name, address, telephone, latitude, longitude) {
  const shortName = name.split(',')[0]
  return {
    title: `Fish & Chips in ${shortName} | The Island House`,
    description: `Order freshly cooked fish and chips from The Island House ${name}. Visit us at ${address} or order online for collection or delivery.`,
    localBusiness: { name: `The Island House ${shortName}`, address, telephone, latitude, longitude }
  }
}

export function applySeo(route) {
  const seo = seoByRoute[route.name] || seoByRoute.home
  const canonical = `${SITE_URL}${route.path === '/' ? '' : route.path}`

  document.title = seo.title
  setMeta('name', 'description', seo.description)
  setMeta('name', 'robots', 'index,follow,max-image-preview:large')
  setMeta('property', 'og:type', 'website')
  setMeta('property', 'og:site_name', 'The Island House')
  setMeta('property', 'og:title', seo.title)
  setMeta('property', 'og:description', seo.description)
  setMeta('property', 'og:url', canonical)
  setMeta('property', 'og:image', `${SITE_URL}/og-image.webp`)
  setMeta('name', 'twitter:card', 'summary_large_image')
  setMeta('name', 'twitter:title', seo.title)
  setMeta('name', 'twitter:description', seo.description)
  setMeta('name', 'twitter:image', `${SITE_URL}/og-image.webp`)
  setCanonical(canonical)
  setStructuredData(route, seo, canonical)
}

function setMeta(attribute, key, content) {
  let el = document.head.querySelector(`meta[${attribute}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attribute, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', url)
}

function setStructuredData(route, seo, canonical) {
  const old = document.getElementById('seo-structured-data')
  if (old) old.remove()

  const graph = [{
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'The Island House',
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.ico`
  }]

  if (seo.localBusiness) {
    const b = seo.localBusiness
    graph.push({
      '@type': 'Restaurant',
      '@id': `${canonical}#restaurant`,
      name: b.name,
      url: canonical,
      telephone: b.telephone,
      servesCuisine: ['Fish and Chips', 'British'],
      priceRange: '£',
      address: { '@type': 'PostalAddress', streetAddress: b.address, addressCountry: 'GB' },
      geo: { '@type': 'GeoCoordinates', latitude: b.latitude, longitude: b.longitude },
      parentOrganization: { '@id': `${SITE_URL}/#organization` }
    })
  }

  const script = document.createElement('script')
  script.id = 'seo-structured-data'
  script.type = 'application/ld+json'
  script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph })
  document.head.appendChild(script)
}
